const HOMEPAGE_INIT_HANDLED_KEY = '_wisp_homepage_init_handled';
const HOMEPAGE_INIT_PENDING_KEY = '_wisp_homepage_init_pending';
const HOMEPAGE_RETRY_BASE_DELAY = 5 * 1000;
const HOMEPAGE_RETRY_MAX_DELAY = 60 * 1000;

let homepageFailureCount = 0;
let homepageNextRetryAt = 0;

function safeLocalStorage() {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.localStorage;
}

export function hasHandledHomepageInitInCurrentLogin() {
  return safeLocalStorage()?.getItem(HOMEPAGE_INIT_HANDLED_KEY) === '1';
}

export function markHomepageInitHandledForCurrentLogin() {
  safeLocalStorage()?.setItem(HOMEPAGE_INIT_HANDLED_KEY, '1');
}

export function clearHomepageInitHandledForCurrentLogin() {
  safeLocalStorage()?.removeItem(HOMEPAGE_INIT_HANDLED_KEY);
}

export function isHomepageInitPending() {
  return safeLocalStorage()?.getItem(HOMEPAGE_INIT_PENDING_KEY) === '1';
}

export function markHomepageInitPending() {
  safeLocalStorage()?.setItem(HOMEPAGE_INIT_PENDING_KEY, '1');
}

export function clearHomepageInitPending() {
  safeLocalStorage()?.removeItem(HOMEPAGE_INIT_PENDING_KEY);
}

// 初始化失败是瞬时网络状态，不能写入 localStorage 变成跨会话的永久抑制。
export function hasHomepageStatusFailedInCurrentLogin() {
  return Date.now() < homepageNextRetryAt;
}

export function markHomepageStatusFailedInCurrentLogin() {
  homepageFailureCount += 1;
  const delay = Math.min(HOMEPAGE_RETRY_BASE_DELAY * 2 ** (homepageFailureCount - 1), HOMEPAGE_RETRY_MAX_DELAY);
  homepageNextRetryAt = Date.now() + delay;
}

export function clearHomepageStatusFailedInCurrentLogin() {
  homepageFailureCount = 0;
  homepageNextRetryAt = 0;
}
